export default __webpack_public_path__ + "static/key_w.9b31669c071f28c91321ab267d6932cc.png";